"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _resetLastFetched = require("./actions/reset-last-fetched");

var _fetchUnreadMessageCount = require("./actions/fetch-unread-message-count");

var _default = function _default(api) {
  return function (store) {
    return function (next) {
      return /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(action) {
          var state, _state$inbox, result;

          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  state = store.getState();
                  _context.t0 = action.type;
                  _context.next = _context.t0 === "root/WS_RECONNECTED" ? 4 : _context.t0 === _fetchUnreadMessageCount.INBOX_FETCH_UNREAD_MESSAGE_COUNT ? 7 : 13;
                  break;

                case 4:
                  store.dispatch((0, _resetLastFetched.resetLastFetched)());
                  store.dispatch((0, _fetchUnreadMessageCount.fetchUnreadMessageCount)());
                  return _context.abrupt("break", 13);

                case 7:
                  store.dispatch((0, _fetchUnreadMessageCount.fetchUnreadMessageCountPending)());
                  _context.next = 10;
                  return api.inboxClient.getInboxCount({
                    from: state === null || state === void 0 ? void 0 : state.from,
                    status: "unread",
                    tenantId: (state === null || state === void 0 ? void 0 : (_state$inbox = state.inbox) === null || _state$inbox === void 0 ? void 0 : _state$inbox.tenantId) || (state === null || state === void 0 ? void 0 : state.tenantId)
                  });

                case 10:
                  result = _context.sent;
                  store.dispatch((0, _fetchUnreadMessageCount.fetchUnreadMessageCountDone)(result));
                  return _context.abrupt("break", 13);

                case 13:
                  next(action);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    };
  };
};

exports["default"] = _default;